import { useState } from "react";

import ZentraqLogo from "./ZentraqLogo";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogin = async () => {
    try {
      setIsSubmitting(true);
      setError("");
      await onLogin(username.trim(), password);
    } catch (loginError) {
      setError(loginError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-title-row">
            <div>
              <p className="eyebrow">ZENTRAQ</p>
              <h1>Anmeldung</h1>
            </div>
            <ZentraqLogo className="brand-logo brand-logo-login" theme="light" />
          </div>
          <p className="section-text">
            Control Your Flow. Melde dich mit deinem Benutzernamen und Passwort an.
          </p>
        </div>

        <div className="form-grid">
          <label className="field">
            <span>Benutzername</span>
            <input
              placeholder="Benutzername"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
            />
          </label>

          <label className="field">
            <span>Passwort</span>
            <input
              placeholder="Passwort"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>

          {error && <div className="message message-error">{error}</div>}

          <button
            onClick={handleLogin}
            className="button button-dark"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Prüfe Anmeldung..." : "Einloggen"}
          </button>
        </div>
      </div>
    </div>
  );
}
